import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const AddAbouts = () => {
const navigate = useNavigate();

const [title, setTitle] = useState("");
const [body, setBody] = useState("");
const [type, setType] = useState("image");

const [imageUrl, setImageUrl] = useState("");
const [videoUrl, setVideoUrl] = useState("");
const [previewUrl, setPreviewUrl] = useState("");

const [uploading, setUploading] = useState(false);
const [saving, setSaving] = useState(false);

// ==========================================
// CANCEL
// ==========================================
const handleCancel = () => {
navigate("/admin/abouts");
};

// ==========================================
// CHANGE TYPE
// ==========================================
const handleTypeChange = (event) => {
const selectedType = event.target.value;


setType(selectedType);

if (selectedType === "image") {
  setPreviewUrl(imageUrl || "");
} else {
  setPreviewUrl("");
}


};

// ==========================================
// UPLOAD IMAGE
// ==========================================
const handleFileChange = async (event) => {
const file = event.target.files?.[0];

if (!file) return;

if (!file.type.startsWith("image/")) {
  toast.error("File yang dipilih harus berupa gambar");
  return;
}

if (file.size > 5 * 1024 * 1024) {
  toast.error("Ukuran gambar maksimal 5MB");
  return;
}

const localPreview = URL.createObjectURL(file);
setPreviewUrl(localPreview);

try {
  setUploading(true);

  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    "/api_w/upload/single",
    formData,
    {
      headers: {
        db_name: process.env.REACT_APP_DB_NAME,
      },
    }
  );

  console.log("UPLOAD RESPONSE:", response.data);

  const uploadedImageUrl =
    response.data?.data?.Location ||
    response.data?.data?.location ||
    response.data?.data?.url ||
    response.data?.Location ||
    response.data?.location ||
    response.data?.url;

  if (!uploadedImageUrl) {
    toast.error("URL gambar hasil upload tidak ditemukan");
    return;
  }

  setImageUrl(uploadedImageUrl);
  setPreviewUrl(uploadedImageUrl);

  toast.success("Gambar berhasil diupload");
} catch (error) {
  console.error("UPLOAD IMAGE ERROR:", error);

  toast.error(
    "Error Upload Gambar: " +
      (error.response?.data?.message ||
        error.response?.data?.error ||
        error.message)
  );
} finally {
  setUploading(false);
}


};

// ==========================================
// SUBMIT ADD
// ==========================================
const handleSubmit = async () => {
if (!title.trim()) {
toast.error("Judul wajib diisi");
return;
}

if (!body.trim()) {
  toast.error("Body wajib diisi");
  return;
}

if (type === "image" && !imageUrl.trim()) {
  toast.error("Gambar wajib diisi");
  return;
}

if (type === "video" && !videoUrl.trim()) {
  toast.error("Video URL wajib diisi");
  return;
}

try {
  setSaving(true);

  const payload = {
    title: title.trim(),
    body: body.trim(),
    type,
    image_url: type === "image" ? imageUrl.trim() : null,
    video_url: type === "video" ? videoUrl.trim() : null,
  };

  console.log("ADD ABOUT PAYLOAD:", payload);

  const response = await axios.post(
    "/api_w/abouts",
    payload,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
        db_name: process.env.REACT_APP_DB_NAME,
        "Content-Type": "application/json",
      },
    }
  );

  console.log("ADD ABOUT RESPONSE:", response.data);

  toast.success("Berhasil menambahkan About!");

  navigate("/admin/abouts");
} catch (error) {
  console.error("ADD ABOUT ERROR:", error);

  console.error(
    "ADD ABOUT RESPONSE:",
    error.response?.data
  );

  toast.error(
    "Error Tambah About: " +
      (error.response?.data?.message ||
        error.response?.data?.error ||
        error.message)
  );
} finally {
  setSaving(false);
}


};

return ( <div className="p-5">
{/* TITLE */} <div className="mb-4"> <label className="mb-2 block text-md font-bold text-gray-800 dark:text-white">
Judul </label>

    <input
      type="text"
      value={title}
      onChange={(e) => setTitle(e.target.value)}
      placeholder="Judul"
      className="block w-full rounded-md border-2 border-gray-300 px-3 py-2 shadow-sm outline-none"
    />
  </div>

  {/* BODY */}
  <div className="mb-4">
    <label className="mb-2 block text-md font-bold text-gray-800 dark:text-white">
      Deskripsi
    </label>

    <textarea
      rows={8}
      value={body}
      onChange={(e) => setBody(e.target.value)}
      placeholder="Deskripsi"
      className="block w-full resize-y rounded-md border-2 border-gray-300 px-3 py-2 shadow-sm outline-none"
    />
  </div>

  {/* TYPE */}
  <div className="mb-4">
    <label className="mb-2 block text-md font-bold text-gray-800 dark:text-white">
      Type
    </label>

    <select
      value={type}
      onChange={handleTypeChange}
      className="block w-full rounded-md border-2 border-gray-300 bg-white px-3 py-2 shadow-sm outline-none"
    >
      <option value="image">Image</option>
      <option value="video">Video</option>
    </select>
  </div>

  {/* IMAGE */}
  {type === "image" && (
    <div className="mb-4">
      <label className="block text-md font-bold text-gray-800 dark:text-white">
        Gambar
      </label>

      <div className="relative mt-2 flex h-60 w-full cursor-pointer items-center justify-center overflow-hidden rounded-md border border-gray-400 bg-gray-200">
        {previewUrl ? (
          <img
            src={previewUrl}
            alt="Preview"
            className="h-full w-full object-cover"
          />
        ) : (
          <span className="text-center text-sm text-gray-600">
            Klik untuk upload gambar
          </span>
        )}

        <input
          type="file"
          accept="image/png,image/jpg,image/jpeg,image/svg+xml,image/webp"
          className="absolute inset-0 cursor-pointer opacity-0"
          onChange={handleFileChange}
          disabled={uploading || saving}
        />
      </div>

      <span className="ml-1 mt-2 block text-xs text-gray-600">
        *Max size: 5MB, Format: .png, .jpg, .jpeg, .svg, .webp
      </span>

      {uploading && (
        <p className="mt-2 text-sm text-blue-600">
          Sedang mengupload gambar...
        </p>
      )}
    </div>
  )}

  {/* VIDEO */}
  {type === "video" && (
    <div className="mb-4">
      <label className="mb-2 block text-md font-bold text-gray-800 dark:text-white">
        Video URL
      </label>

      <input
        type="text"
        value={videoUrl}
        onChange={(e) => setVideoUrl(e.target.value)}
        placeholder="Masukkan URL video"
        className="block w-full rounded-md border-2 border-gray-300 px-3 py-2 shadow-sm outline-none"
      />

      {videoUrl && (
        <div className="mt-3">
          <p className="mb-2 text-sm text-gray-600">
            Preview Video:
          </p>

          <video
            src={videoUrl}
            controls
            className="h-60 w-full rounded-md bg-black object-contain"
          />
        </div>
      )}
    </div>
  )}

  {/* BUTTON */}
  <div className="flex justify-end gap-4">
    <button
      type="button"
      onClick={handleCancel}
      disabled={saving || uploading}
      className="rounded bg-red-500 px-4 py-2 font-bold text-white hover:bg-red-600 disabled:cursor-not-allowed disabled:opacity-50"
    >
      Batal
    </button>

    <button
      type="button"
      onClick={handleSubmit}
      disabled={saving || uploading}
      className="rounded bg-green-600 px-4 py-2 font-bold text-white hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {saving ? "Menyimpan..." : "Simpan"}
    </button>
  </div>
</div>


);
};

export default AddAbouts;
